"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightToolBar = exports.CenterToolBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const call_tools_1 = require("./tools/call_tools");
const toolbar_call_details_1 = require("./tools/toolbar_call_details");
const local_audio_mute_button_1 = require("./tools/local_audio_mute_button");
const gps_button_1 = require("./tools/gps_button");
const company_settings_1 = require("../../../context/company_settings");
const end_call_button_1 = require("./tools/end_call_button");
const guide_button_1 = require("./tools/guide_button");
const toggle_camera_button_1 = require("./tools/toggle_camera_button");
const room_session_1 = require("../../../context/room_session");
const use_camera_subject_1 = require("../../../hooks/use_camera_subject");
const use_video_enabled_1 = require("../../../hooks/use_video_enabled");
const operators_1 = require("rxjs/operators");
const sdk_core_1 = require("@streem/sdk-core");
const bookmark_button_1 = require("./tools/bookmark_button");
const get_protobuf_timestamp_1 = require("../../../util/get_protobuf_timestamp");
const timer_1 = require("./tools/timer");
const rxjs_1 = require("../../../hooks/rxjs");
const local_audio_input_select_1 = require("./tools/local_audio_input_select");
const use_is_backgrounded_1 = require("../../../hooks/use_is_backgrounded");
const local_video_input_select_1 = require("./tools/local_video_input_select");
const use_video_muted_1 = require("../../../hooks/use_video_muted");
const CenterToolBar = ({ setShowArrow, remoteUserName, isTrayOpen }) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const roomSession = (0, room_session_1.useRoomSession)();
    const isWorld = (0, use_camera_subject_1.hasWorldSubject)(roomSession.media.videoControllers);
    const isScreen = (0, use_camera_subject_1.hasScreenSubject)(roomSession.media.videoControllers);
    const faceToFace = !isWorld && !isScreen;
    const remoteVideoController = roomSession.media.videoControllers.pipe((0, operators_1.scan)((acc, controllers) => {
        return controllers.find(controller => !controller.ownerIsLocalUser) || acc;
    }, undefined));
    const [remoteVideoEnabled] = (0, use_video_enabled_1.useVideoEnabled)(remoteVideoController);
    const [remoteVideoMuted] = (0, use_video_muted_1.useVideoMuted)(remoteVideoController);
    const [isBackgrounded] = (0, use_is_backgrounded_1.useIsBackgrounded)(remoteVideoController);
    const addBookmark = () => {
        roomSession.bookmarks.addBookmark({
            timestamp: (0, get_protobuf_timestamp_1.getProtobufTimestamp)(),
        });
    };
    // Disable tools in faceMode mode, if the remote video has not been enabled or if the remote video is backgrounded
    const areToolsDisabled = (0, sdk_core_1.isOnSiteRoomSession)(roomSession)
        ? faceToFace
        : faceToFace || !remoteVideoEnabled || remoteVideoMuted || isBackgrounded;
    const show = () => {
        setShowTooltip(true);
        if (setShowArrow) {
            setShowArrow(true);
        }
    };
    const hide = () => {
        setShowTooltip(false);
        if (setShowArrow) {
            setShowArrow(false);
        }
    };
    const name = remoteUserName ? remoteUserName + "'s" : 'their';
    const faceToFaceMessage = ((0, jsx_runtime_1.jsxs)(ui_react_1.Row, Object.assign({ alignItems: "center", style: { padding: '12px' } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "grey80" }, { children: "Flip" })), (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { margin: '0 5px 0 5px' } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "FlipIcon", size: "small", color: ui_react_1.Theme.colors.grey80 }) })), (0, jsx_runtime_1.jsxs)(ui_react_1.AppText, { children: [name, " camera to enable tools."] })] })));
    const noRemoteVideoMessage = ((0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ alignItems: "center", style: { padding: '12px' } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, { children: "Turn on camera to enable tools." }) })));
    const remoteVideoBackgroundedMessage = ((0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ alignItems: "center", style: { padding: '12px' } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, { children: "Tools disabled while backgrounded." }) })));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ message: faceToFace
                    ? faceToFaceMessage
                    : isBackgrounded
                        ? remoteVideoBackgroundedMessage
                        : noRemoteVideoMessage, showTooltip: areToolsDisabled ? showTooltip : false, borderRadius: "10px", arrowSize: "20px", distance: 30 }, { children: (0, jsx_runtime_1.jsx)(CenterToolbarWrapper, Object.assign({ onMouseEnter: show, onMouseOver: show, onMouseOut: hide, onFocus: show, onBlur: hide }, { children: (0, jsx_runtime_1.jsx)(call_tools_1.CallTools, { isTrayOpen: isTrayOpen, disabled: !!areToolsDisabled }) })) })), (0, jsx_runtime_1.jsx)(bookmark_button_1.BookmarkButton, { addBookmark: addBookmark })] }));
};
exports.CenterToolBar = CenterToolBar;
const RightToolBar = ({ handleGuideToggle, isTrayOpen, remoteIsARCapable, showGuideUI, }) => {
    const settings = (0, company_settings_1.useCompanySettings)();
    const roomSession = (0, room_session_1.useRoomSession)();
    const [callStartTime] = (0, rxjs_1.useObservable)(roomSession.bookmarks.callStartTime);
    return ((0, jsx_runtime_1.jsxs)(RightToolbarWrapper, { children: [(0, jsx_runtime_1.jsx)(toolbar_call_details_1.ToolbarCallDetails, { isTrayOpen: isTrayOpen }), (0, jsx_runtime_1.jsxs)(RightToolbarToolsWrapper, { children: [(settings === null || settings === void 0 ? void 0 : settings.arEnabled) && remoteIsARCapable && ((0, jsx_runtime_1.jsx)(guide_button_1.GuideButton, { handleGuideToggle: handleGuideToggle, showGuideUI: showGuideUI })), (settings === null || settings === void 0 ? void 0 : settings.gpsEnabled) && (0, jsx_runtime_1.jsx)(gps_button_1.GPSbutton, {}), (0, jsx_runtime_1.jsx)(local_audio_mute_button_1.LocalAudioMuteButton, {}), (0, jsx_runtime_1.jsx)(local_audio_input_select_1.LocalAudioInputSelect, {}), (0, jsx_runtime_1.jsx)(toggle_camera_button_1.ToggleCameraButton, {}), (0, jsx_runtime_1.jsx)(local_video_input_select_1.LocalVideoInputSelect, {}), (0, jsx_runtime_1.jsx)(timer_1.Timer, { callStartTime: callStartTime === null || callStartTime === void 0 ? void 0 : callStartTime.clientCreatedAt }), (0, jsx_runtime_1.jsx)(end_call_button_1.EndCallButton, {})] })] }));
};
exports.RightToolBar = RightToolBar;
const CenterToolbarWrapper = ui_react_1.styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '2px 0',
}));
const RightToolbarToolsWrapper = ui_react_1.styled.div(({ theme }) => ({
    backgroundColor: theme.colors.white,
    borderTopLeftRadius: '28px',
    borderBottomLeftRadius: '28px',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    marginLeft: theme.spacing.s,
}));
const RightToolbarWrapper = ui_react_1.styled.div(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginLeft: 'auto',
}));
//# sourceMappingURL=index.js.map